import React from 'react';
import { WithStylesProps } from 'react-jss';

import { TextArea } from '~/eds/src/components/TextArea/TextArea';

import styles from '../InformationField.styles';
import { Field } from '../InformationFieldV2';

interface TextAreaFieldProps extends WithStylesProps<typeof styles> {
  field: Field;
  editMode: boolean;
  fieldValue: any;
  setFieldValue: (value: any) => void;
}

export const TextAreaField = ({
  classes,
  field,
  editMode,
  fieldValue,
  setFieldValue,
}: TextAreaFieldProps) => {
  return (
    <div className={classes.editItemContainer}>
      <TextArea
        name={field.name}
        aria-label={field.name}
        value={fieldValue ? fieldValue.value : ''}
        rows={7}
        disabled={!editMode}
        onChange={(content) => {
          if (content) {
            setFieldValue({
              display_value: content,
              value: content,
            });
          }
        }}
      />
    </div>
  );
};
